module.exports = __webpack_public_path__ + "img/congrats.72c9f162.png";